import React, { useState } from 'react';
import { VectorSource } from '@avinet/react-openlayers';
import { featureStyle } from '../../utils/featureStyle';

const Result = ({ results, onSelect }) => {
  const [selected, setSelected] = useState('');
  const [feature, setFeature] = useState();

  // Order results based on searchResultOrder in results --> leads to listing each dataset in a defined order
  const orderedResults = [...results].sort((a, b) => {
    const orderA = a.searchResultOrder || Infinity;
    const orderB = b.searchResultOrder || Infinity;
    return orderA - orderB;
  });

  const layerGroupNames = [...new Set(orderedResults.map(result => result.datasetTitle))];

  return (
    <div className="search--searchSources" tabIndex={0}>
      {layerGroupNames.map((dataset, i) => {
        const resultList = results.filter(result => result.datasetTitle === dataset);
        const numResults = resultList.length;

        return (
          <div className="searchSource--container" key={i} tabIndex={0}>
            <div className="dataset-header--container">
              <h2>
                {dataset} ({numResults})
              </h2>
              {numResults > 5 && (
                <button
                  className="pull-right btn btn-link"
                  title={'showAllResults'}
                  onClick={() =>
                    dataset === selected ? setSelected(undefined) : setSelected(dataset)
                  }
                >
                  {selected === dataset ? 'Back' : 'Show all results'}
                </button>
              )}
            </div>
            <ul className={numResults === 0 ? 'searchSource--noResults' : ''}>
              {resultList.slice(0, selected === dataset ? numResults : 5).map(result => {
                const stripHtml = str => str.replace(/<[^>]*>/g, '');
                const formattedTitle =
                  result.searchTitleFormat && result.searchTitleFormat.trim() !== ''
                    ? stripHtml(
                        result.searchTitleFormat.replace(
                          /{(\w+)}/g,
                          (_, prop) => result.data[prop] ?? ''
                        )
                      )
                    : stripHtml(result.title);

                return (
                  <li
                    key={result.uid}
                    className="clearfix"
                    onClick={() => onSelect(result)}
                    onMouseOver={() => setFeature(result.olFeature)}
                    onMouseOut={() => setFeature(undefined)}
                  >
                    <h3>{formattedTitle}</h3>
                  </li>
                );
              })}
            </ul>
          </div>
        );
      })}
      {feature && (
        <VectorSource
          layerName="hover"
          features={[feature]}
          selectable={false}
          style={featureStyle}
        />
      )}
    </div>
  );
};

export default Result;
